import {type FunctionalComponent, h} from '@stencil/core';


interface SeeMoreProps{
    enabled:boolean,
    urlPattern: string,
    labelProvider:CallableFunction,
    term: string,
}

export const SeeMoreLinks:FunctionalComponent<SeeMoreProps> = (props)=>{
    const {enabled, urlPattern, labelProvider, term} = props;
    if(!enabled)
      return '';

    const safeTerm = encodeURIComponent(term);
    const openUrl = urlPattern
      .replace('$TERM', safeTerm);

    return <div class="guided-pane__see-more-results">
      <a href={openUrl}>
        {labelProvider('see-more-links','See more links')}
      </a>
    </div>;
};
